import { useMemo } from "react";
import { MRT_ColumnDef } from "mantine-react-table";
import { Badge } from "@mantine/core";
import { getRegtankColor } from "../../../../Utils/getRegtankDetails";
import { RegtankLivenessFHStatusEnum } from "@funded-here-interface/common/src/constant/enum";
import type { RegtankLivenessData } from "../Regtank.types";

/**
 * Column definitions for company liveness table
 * Used for displaying liveness verification status for company users (directors, shareholders, etc.)
 */
export const useLivenessColumns = () => {
  return useMemo<MRT_ColumnDef<RegtankLivenessData>[]>(
    () => [
      {
        accessorKey: "name",
        header: "Full Name",
      },
      {
        accessorKey: "email",
        header: "Email",
      },
      {
        accessorKey: "userRole",
        header: "User Type",
      },
      {
        accessorKey: "verificationStatus",
        header: "Verification Status",
        Cell: ({ cell }) => {
          const label = getRegtankColor(
            cell.getValue<RegtankLivenessFHStatusEnum>()
          );
          if (label === "gray") {
            return null;
          } else {
            return (
              <Badge
                color={getRegtankColor(
                  cell.getValue<RegtankLivenessFHStatusEnum>()
                )}
              >
                {cell.getValue<RegtankLivenessFHStatusEnum>()}
              </Badge>
            );
          }
        },
      },
      {
        accessorKey: "lastAttemptDate",
        header: "Last Attempt On",
      },
    ],
    []
  );
};
